<template>
  <li>
    <div v-if="hasOwnSite" class="own-site-box">
      <span v-if="item.isOwnSite" class="own-site">登録サイト</span>
    </div>
    <template v-if="!item.url && item.isOwnSite">
      <span class="rank">圏外</span>
      <span class="exception-txt">
        100位以内に登録サイトのデータが存在しません。
      </span>
    </template>
    <template v-else>
      <span class="rank">{{ item.rank }}位</span>
      <template v-if="item.headers.total === null">
        <span class="exception-txt">
          見出しの個数を取得中です。
        </span>
      </template>
      <template v-else-if="typeof item.headers.total === 'undefined'">
        <div class="exception-txt">
          見出しの個数を取得できませんでした。
          <Tooltip variant="attention" position="left-top">
            データの取得ができませんでした。
            原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
          </Tooltip>
        </div>
      </template>
      <template v-else-if="item.contentType === 'pdf'">
        <span class="exception-txt">
          PDFのため分析ができません。
        </span>
      </template>
      <template
        v-else-if="
          item.headers.h1.length === 0 &&
            item.headers.h2.length === 0 &&
            item.headers.h3.length === 0
        "
      >
        <div class="exception-txt">
          見出しの個数を取得できませんでした。
          <Tooltip variant="attention" position="left-top">
            データの取得ができませんでした。
            原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
          </Tooltip>
        </div>
      </template>
      <template v-else>
        <span class="num">{{ item.headers.total | separateNumber }}個</span>
        <div class="line">
          <div
            v-if="countH1 !== 0"
            :style="{ background: '#e96908', width: barW.h1 + '%' }"
          >
            <span class="balloon">{{ countH1 }}</span>
          </div>
          <div
            v-if="countH2 !== 0"
            :style="{ background: '#f1c139', width: barW.h2 + '%' }"
          >
            <span class="balloon">{{ countH2 }}</span>
          </div>
          <div
            v-if="countH3 !== 0"
            :style="{ background: '#a679d6', width: barW.h3 + '%' }"
          >
            <span class="balloon">{{ countH3 }}</span>
          </div>
        </div>
      </template>
    </template>
  </li>
</template>

<script>
import Tooltip from '@/components/Tooltip';

export default {
  props: ['item', 'max', 'hasOwnSite'],
  components: {
    Tooltip
  },
  data() {
    return {
      barW: {
        total: null,
        h1: 0,
        h2: 0,
        h3: 0
      },
      timeout: null
    };
  },
  watch: {
    'item.headers.total': {
      handler(value) {
        this.update();
      }
    },
    max: {
      handler(value) {
        this.update();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeout = setTimeout(() => {
        this.update();
      }, 100);
    });
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
  computed: {
    countH1() {
      if (this.item.headers.h1 && this.item.headers.h1.length) {
        return this.item.headers.h1.length;
      } else {
        return 0;
      }
    },
    countH2() {
      if (this.item.headers.h2 && this.item.headers.h2.length) {
        return this.item.headers.h2.length;
      } else {
        return 0;
      }
    },
    countH3() {
      if (this.item.headers.h3 && this.item.headers.h3.length) {
        return this.item.headers.h3.length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    update() {
      let total = this.item.headers.total;
      if (total && this.max) {
        this.barW.total = (total / this.max) * 100;
      }
      if (this.countH1 && this.max) {
        this.barW.h1 = (this.countH1 / this.max) * 100;
      }
      if (this.countH2 && this.max) {
        this.barW.h2 = (this.countH2 / this.max) * 100;
      }
      if (this.countH3 && this.max) {
        this.barW.h3 = (this.countH3 / this.max) * 100;
      }
    }
  }
};
</script>
